if (!customElements.get('product-form')) {
  const GLOOD_UPSELL_ERROR_MESSAGE = '一部の追加商品をカートに追加できませんでした。カート内容をご確認ください。';
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      if (this.querySelector('form')) {
        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
      else {
        this.querySelector('[name=id]').disabled = false;
        this.querySelector('button[type=submit]').addEventListener('click', this.onSubmitHandler.bind(this));
      }

      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer') && this.submitButton) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton && this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      if (this.submitButton) {
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
      }
      this.querySelector('.loading-overlay__spinner')?.classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (!this.form) {
        formData.append('id', this.querySelector('[name=id]').value);
      }
      
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then(async (response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);
            const soldOutMessage = this.submitButton?.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            if (this.submitButton) {
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span')?.classList.add('hidden');
            }
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          }

          let gloodUpsellFailed = false;

          if (window.Glood?.upsell) {
            try {
              await Glood.upsell.commitPickSelections({
                triggerVariantId: response.variant_id
              });
              await Glood.upsell.refresh();
            } catch (err) {
              gloodUpsellFailed = true;
              console.error('[GLOOD]:[UPSELL] Error while adding upsell to cart', err);
            }
          }

          if (this.cart) {
            const sectionIds = this.cart.getSectionsToRender().map((section) => section.id);
            try {
              const sectionsResponse = await fetch(`${routes.cart_url}?sections=${sectionIds.join(',')}&sections_url=${encodeURIComponent(window.location.pathname)}`);
              const freshSections = await sectionsResponse.json();
              response.sections = freshSections;
            } catch (err) {
              console.error('Failed to refresh cart sections after upsell commit', err);
            }
          }

          // Reset the container so that prices can be updated
          document
            .querySelectorAll('[data-glood-mini-cart-line]')
            .forEach((line) => (line.dataset.gloodPriceUpdated = 'false'));

          if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
          this.error = false;
          const showUpsellError = () => {
            if (gloodUpsellFailed) {
              this.cart.showCartError?.(GLOOD_UPSELL_ERROR_MESSAGE);
            } else {
              this.cart.clearCartError?.();
            }
          };
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => {
                this.cart.renderContents(response);
                showUpsellError();
              });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
            showUpsellError();
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          if (this.submitButton) {
            this.submitButton.classList.remove('loading');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          }
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          this.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
